import { Role } from '@/Enums/Users/Role.enum';
import { ApprovalStatus } from '@/Interfaces/ApprovalStatus.enum';
import { InputLabel, MenuItem, Select } from '@mui/material';
import { useMemo } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';

interface IProps {
  userRole: Role;
}

const CampaignsApprovalSelect = ({ userRole }: IProps) => {
  const { control } = useFormContext();

  const whitelabel = useWatch({ control, name: 'whitelabel' });
  const organization = useWatch({ control, name: 'organization' });

  const isControlEnabled = useMemo(() => {
    switch (userRole) {
      case Role.ADMIN:
        return true;
      case Role.ORG_ADMIN:
        return organization?.requiresCampaignApproval ?? false;
      default:
        return whitelabel?.requiresCampaignApproval ?? false;
    }
  }, [userRole, whitelabel, organization]);

  return (
    <div className='mt-4 flex-1'>
      <InputLabel htmlFor='can-approve-campaigns'>Grant Campaign Management Approver Status to this user?</InputLabel>
      <Controller
        name='canApproveCampaigns'
        control={control}
        render={({ field }) => (
          <Select
            {...field}
            fullWidth
            renderValue={value => (value ? ApprovalStatus.YES : ApprovalStatus.NO)}
            onChange={e => field.onChange(e.target.value === ApprovalStatus.YES)}
            disabled={!isControlEnabled}
          >
            {Object.values(ApprovalStatus).map(value => (
              <MenuItem key={value} value={value}>
                {value}
              </MenuItem>
            ))}
          </Select>
        )}
      />
    </div>
  );
};

export default CampaignsApprovalSelect;
